import { Inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { VersionCheckService } from "@app/services/VersionCheck.service";
import { catchError, timeout } from "rxjs/operators";
import { WindowToken } from "@app/util/window.token";
import { CommonService } from "@app/services/CommonService";


@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(@Inject(VersionCheckService) private versionCheckService: VersionCheckService,
                @Inject(CommonService) private commonService: CommonService,
                @Inject(WindowToken) public window) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const auth_token = sessionStorage.getItem("hoapay_accessToken");

        if (req.url.indexOf('.html') > -1) {
            return next.handle(req);
        }

        let headers = req.headers.set("ClientVersion", this.versionCheckService.localVersion());

        if (auth_token) {
            headers = headers.set("Authorization", `Bearer ${auth_token}`)
        }

        const newReq = req.clone({
            withCredentials: true,
            headers,
        });

        // timeout // backend is set to 2 min so this is 5 sec longer
        return next.handle(newReq).pipe(
            timeout(125000),
            catchError(returnedError => {

                if (returnedError.status === 403) {
                    this.commonService.setUnauthorized();
                } else if (returnedError.status === 401) {
                    this.commonService.setExpiredToken();
                }

                return throwError(returnedError);
            })
        ) as Observable<HttpEvent<any>>;
    }

}
